import { useMemo } from "react";
import { useAuthContext } from "@/context";
import { RequestConfig } from "./use-api-client";
export type { RequestConfig } from "./use-api-client";

export function useAuthRequestConfig<T extends RequestConfig>(config: T): T {
  const { token } = useAuthContext();

  const memoized = useMemo(() => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    },
  }), [config, token]);

  return token ? memoized : config;
}
